import { LazyImage } from '@components/common/image'

type Props = {
  imagePath: string
  imageName: string
  title: string
  ctaLink: string
  ctaText: string
}

const ResourceCard = ({
  imagePath,
  imageName,
  title,
  ctaLink,
  ctaText,
}: Props) => (
  <div className="group flex flex-col rounded-lg shadow-lg hover:shadow-xl overflow-hidden text-grey-900 w-96 bg-white">
    <LazyImage
      path={imagePath}
      name={imageName}
      className="h-56"
      alt={`app development masterclasses ${title}`}
    />
    <div className="px-10 py-8">
      <h3 className="font-700 text-xl mb-8 h-16">{title}</h3>
      <a
        href={ctaLink}
        target="_blank"
        rel="noreferrer noopener"
        className="btn text-lg font-600 btn bg-white align-middle text-orange font-medium py-2 px-5 group-hover:text-white group-hover:bg-orange-600 rounded focus:outline-none"
      >
        {ctaText}
      </a>
    </div>
  </div>
)

export default ResourceCard
